// Aggregates the dummy-data JSON files into one DATA object, mirroring the
// design project's bb/data.jsx structure.
import companyJson from "./company.json";
import homeJson from "./home.json";
import inboxJson from "./inbox.json";
import kpisJson from "./kpis.json";
import cashflowJson from "./cashflow.json";
import transactionsJson from "./transactions.json";
import bankJson from "./bank.json";
import agentsJson from "./agents.json";
import approvalsJson from "./approvals.json";
import askaiJson from "./askai.json";
import settingsJson from "./settings.json";

export const DATA = {
  company: companyJson.company,
  user: companyJson.user,

  snapshot: homeJson.snapshot,
  priority: homeJson.priority,
  health: homeJson.health,
  recentAiActivity: homeJson.recentAiActivity,

  inbox: inboxJson.inbox,
  activity: inboxJson.activity,

  kpis: kpisJson.kpis,

  cashSeries: cashflowJson.cashSeries,
  cashAccounts: cashflowJson.cashAccounts,
  obligations: cashflowJson.obligations,
  collections: cashflowJson.collections,
  flow: cashflowJson.flow,
  expenseCats: cashflowJson.expenseCats,
  budgetVsForecast: cashflowJson.budgetVsForecast,
  upcoming14: cashflowJson.upcoming14,

  txns: transactionsJson.txns,
  txnKpis: transactionsJson.txnKpis as Record<string, (string | boolean)[][]>,

  bankAccounts: bankJson.bankAccounts,
  bankLedger: bankJson.bankLedger,

  agents: agentsJson.agents,
  skills: agentsJson.skills,
  libraryAvailable: agentsJson.libraryAvailable,
  agentActivity: agentsJson.activity as Record<string, AgentActivityGroup[]>,

  approvals: approvalsJson.approvals,

  aiSuggested: askaiJson.suggested,
  aiScreenSuggested: askaiJson.screenSuggested,
  aiModels: askaiJson.models,
  aiHistory: askaiJson.history,
  aiReports: askaiJson.reports,

  teamMembers: settingsJson.teamMembers,
  teamPending: settingsJson.teamPending,
  billingPlans: settingsJson.billingPlans,
  billingRows: settingsJson.billingRows,
  integrationsConnected: settingsJson.integrationsConnected,
  integrationsAvailable: settingsJson.integrationsAvailable,
};

export interface AgentActivityItem {
  kind: string;
  title: string;
  time: string;
  status: string;
  impact?: string;
  reasoning?: string;
  actions?: string[];
  plan?: boolean;
  rec?: string;
}

export interface AgentActivityGroup {
  group: string;
  items: AgentActivityItem[];
}

export type Agent = (typeof DATA.agents)[number];
export type Txn = (typeof DATA.txns)[number];

export const agentById = (id: string) => DATA.agents.find((a) => a.id === id);

/** Navigation callback shared by screens: (section, tab?) */
export type NavFn = (section: string, tab?: string) => void;
